import { useEffect, useMemo, useState } from 'react';
import { Clock3 } from 'lucide-react';
import {
  formatPosCaisseClockDate,
  formatPosCaisseClockTime,
  resolvePosDisplayTimeZone,
} from '../../utils/posCaisseClock';

/**
 * Horloge POS (affichage local commerce) — n’altère aucun horodatage serveur.
 */
export default function PosCaisseHeaderClock({
  commercantTimeZone,
  className = '',
  variant = 'light',
  clockSource = 'fallback',
}) {
  const { timeZone, fallbackUsed } = useMemo(
    () => resolvePosDisplayTimeZone(commercantTimeZone),
    [commercantTimeZone]
  );
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const dateLabel = formatPosCaisseClockDate(now, timeZone);
  const timeLabel = formatPosCaisseClockTime(now, timeZone);
  const title =
    clockSource === 'commercant' && !fallbackUsed
      ? `Heure locale du commerce (${timeZone})`
      : `Heure locale (${timeZone}) — fuseau commerce non configuré en Admin ; repli Europe/Paris`;

  const isDark = variant === 'dark';
  const dateClass = isDark ? 'text-slate-400' : 'text-slate-500';
  const timeClass = isDark ? 'text-slate-100' : 'text-slate-900';
  const iconClass = isDark ? 'text-slate-500' : 'text-slate-400';

  return (
    <div
      data-testid="pos-caisse-header-clock"
      data-pos-clock-timezone={timeZone}
      title={title}
      className={`inline-flex items-center gap-2 text-right min-w-0 ${className}`}
      aria-live="off"
    >
      <Clock3 className={`h-4 w-4 shrink-0 hidden sm:block ${iconClass}`} aria-hidden />
      <div className="min-w-0 leading-tight">
        <p
          className={`text-[11px] sm:text-xs capitalize truncate max-w-[14rem] sm:max-w-none ${dateClass}`}
        >
          {dateLabel}
        </p>
        <p className={`text-sm sm:text-base font-semibold tabular-nums ${timeClass}`}>{timeLabel}</p>
      </div>
    </div>
  );
}
